import { colors } from './core'
import { textStyles } from './typography'
import { muiColors } from '../mui/DefaultTheme'

const buttons = {
  primary: {
    transition: 'background-color 0.3s cubic-bezier(0.47, 0, 0.75, 0.72)',
    backgroundColor: 'secondary.1',
    border: 'none',
    color: 'neutrals.0',
    boxShadow: `0px 4px 14px 0px ${colors.secondary[1]}59`,
    svg: {
      path: {
        fill: 'neutrals.0'
      },
      circle: {
        stroke: 'neutrals.0'
      }
    },
    '@media (hover: hover)': { // Only apply these styles if the browser supports proper/true/real/non-emulated hovering (e.g. has a mouse-like primary input device)
      '&:hover, &:focus': {
        backgroundColor: 'secondary.2'
      }
    },
    '&:disabled': {
      backgroundColor: 'neutrals.2',
      boxShadow: 'none'
    }
  },
  secondary: {
    backgroundColor: 'neutrals.0',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'secondary.1',
    color: 'secondary.1',
    svg: {
      path: {
        fill: 'secondary.1'
      },
      circle: {
        stroke: 'secondary.1'
      }
    },
    '@media (hover: hover)': { // Only apply these styles if the browser supports proper/true/real/non-emulated hovering (e.g. has a mouse-like primary input device)
      '&:hover': {
        color: 'secondary.2',
        borderColor: 'secondary.2',
        borderWidth: '2px',
        margin: '-1px',
        svg: {
          mr: '-2px',
          path: {
            fill: 'secondary.2'
          },
          circle: {
            stroke: 'secondary.2'
          }
        }
      }
    },
    '&:disabled': {
      color: 'neutrals.2',
      borderColor: 'neutrals.2',
      svg: {
        path: {
          fill: 'neutrals.2'
        },
        circle: {
          stroke: 'neautrals.2'
        }
      }
    }
  },
  tertiary: {
    backgroundColor: 'transparent',
    color: 'neutrals.3',
    border: 'none',
    py: 3,
    px: 0,
    minWidth: '100%',
    minHeight: 'auto',
    svg: {
      path: {
        fill: 'neutrals.3'
      },
      order: 0,
      ml: 0,
      mr: 5
    },
    span: {
      order: 1
    },
    '@media (hover: hover)': { // Only apply these styles if the browser supports proper/true/real/non-emulated hovering (e.g. has a mouse-like primary input device)
      '&:hover': {
        color: 'secondary.2',
        svg: {
          path: {
            fill: 'secondary.2'
          }
        }
      }
    },
    '&:disabled': {
      color: 'neutrals.2',
      svg: {
        path: {
          fill: 'neutrals.2'
        }
      }
    }
  },
  prominentColourScheme: {
    transition: 'background-color 0.3s cubic-bezier(0.47, 0, 0.75, 0.72)',
    backgroundColor: muiColors.prominent.blue(),
    border: 'none',
    color: 'neutrals.0',
    boxShadow: `0px 4px 14px 0px ${colors.secondary[1]}59`,
    svg: {
      path: {
        fill: 'neutrals.0'
      },
      circle: {
        stroke: 'neutrals.0'
      }
    },
    '@media (hover: hover)': { // Only apply these styles if the browser supports proper/true/real/non-emulated hovering (e.g. has a mouse-like primary input device)
      '&:hover, &:focus': {
        backgroundColor: muiColors.prominent.darkBlue()
      }
    },
    '&:disabled': {
      backgroundColor: 'neutrals.2',
      boxShadow: 'none'
    }
  }
}

const buttonSizes = {
  largeCenteredText: {
    textAlign: 'center',
    py: 3,
    pr: 3,
    pl: 6,
    minWidth: '100%',
    minHeight: '72px',
    borderRadius: '150px',
    ...textStyles.body.regular.medium
  },
  large: {
    textAlign: 'left',
    py: 3,
    pr: 3,
    pl: 6,
    minWidth: '100%',
    minHeight: '72px',
    borderRadius: '150px',
    ...textStyles.body.regular.medium
  },
  medium: {
    textAlign: 'left',
    py: 4,
    pl: 6,
    pr: 5,
    minWidth: '100%',
    borderRadius: '70px',
    ...textStyles.body.regular.medium
  },
  small: {
    textAlign: 'left',
    py: 1,
    px: 3,
    borderRadius: '70px',
    boxShadow: 'none !important',
    ...textStyles.body.smallPrint.regular
  }
}

export { buttons, buttonSizes }
